var _Glyphicon;
import PropTypes from 'prop-types';
import React from 'react';
import { sendClick } from 'reaxl-analytics';
import { ownerLocation } from 'reaxl-analytics-handlers';
import { Address, Button, Glyphicon, IconButton, LinkIcon } from 'reaxl';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function AddressLinkIcon(_ref) {
  let {
    map,
    uiContext,
    linkClassName,
    iconClassName,
    address = {},
    handleClick = () => {},
    ...restLocationProps
  } = _ref;
  const props = {
    className: linkClassName,
    placement: 'after',
    glyph: 'offsite',
    target: '_blank',
    rel: 'nofollow noopener',
    onClick: handleClick,
    undecorated: true,
    ...map,
    ...restLocationProps
  };
  if (uiContext === 'button') {
    props.glyph = 'directions';
    props.placement = 'none';
    props['aria-label'] = 'Directions';
    props.glyphClassName = iconClassName;
  }
  return /*#__PURE__*/_jsx(LinkIcon, {
    ...props,
    children: uiContext !== 'button' && /*#__PURE__*/_jsx(Address, {
      className: "display-inline",
      inline: true,
      location: address
    })
  });
}
function AddressButton(_ref2) {
  let {
    btnProps,
    map,
    handleClick,
    iconClassName
  } = _ref2;
  return /*#__PURE__*/_jsx(Button, {
    target: "_blank",
    rel: "nofollow noopener",
    onClick: handleClick,
    "aria-label": "Directions",
    ...btnProps,
    ...map,
    children: /*#__PURE__*/_jsx(Glyphicon, {
      glyph: "directions",
      className: iconClassName
    })
  });
}
const getAddress = _ref3 => {
  let {
    handleClick,
    location = {},
    uiContext = 'default',
    linkClassName,
    iconClassName,
    btnProps = {},
    isVirtual,
    distanceFromSearch
  } = _ref3;
  const {
    map,
    address,
    ...rest
  } = location;
  if (uiContext === 'button' && map) {
    return /*#__PURE__*/_jsx(AddressButton, {
      map,
      btnProps,
      handleClick,
      iconClassName
    });
  }
  if (uiContext === 'default' && map && address) {
    return /*#__PURE__*/_jsx(AddressLinkIcon, {
      map,
      uiContext,
      linkClassName,
      address,
      handleClick,
      ...rest
    });
  }
  if (address && (uiContext === 'unclickable' || !map && uiContext === 'default')) {
    return /*#__PURE__*/_jsx(Address, {
      inline: true,
      location: address
    });
  }
  if (uiContext === 'snapshot' && map && address) {
    const isDistanceViewable = !!distanceFromSearch && distanceFromSearch !== 0 && !isVirtual;
    return /*#__PURE__*/_jsxs("div", {
      className: "display-flex text-center text-size-300",
      children: [_Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
        glyph: "map-marker",
        className: "margin-right-3 text-size-500"
      }, "map-marker-icon")), /*#__PURE__*/_jsxs("div", {
        className: "display-flex flex-column align-items-start text-wrap-pretty",
        children: [/*#__PURE__*/_jsx(AddressLinkIcon, {
          map,
          uiContext,
          linkClassName,
          address,
          handleClick,
          ...rest
        }, "distance_address"), isDistanceViewable && /*#__PURE__*/_jsxs("span", {
          className: "text-size-200 text-subdued-lighter",
          children: [distanceFromSearch, ' ', "miles away"]
        }, "distance_text")]
      }, "distance_address_text")]
    }, "distance_snapshot-container");
  }
  return null;
};
function OwnerAddress(_ref4) {
  let {
    wrapperComponent,
    wrapperProps = {},
    analyticsData,
    uiContext,
    isVirtual = false,
    distanceFromSearch,
    ...rest
  } = _ref4;
  const handleClick = event => sendClick(ownerLocation, event, analyticsData);

  // Short circuit complex component for simple icon button implementation
  if (uiContext === 'iconbutton') {
    const {
      location: {
        map
      } = {}
    } = rest;
    return map && /*#__PURE__*/_jsx(IconButton, {
      glyph: "directions",
      label: "Directions",
      layout: "stacked",
      onClick: handleClick,
      rel: "nofollow noopener",
      size: "large",
      target: "_blank",
      ...map
    });
  }
  const ownerAddress = getAddress({
    handleClick,
    uiContext,
    isVirtual,
    distanceFromSearch,
    ...rest
  });
  return ownerAddress && wrapperComponent ? /*#__PURE__*/React.createElement(wrapperComponent, wrapperProps, ownerAddress) : ownerAddress;
}
export default OwnerAddress;